// Périodes d'un relevé en dates locales AAAA-MM-JJ : choix rapides, mois de la liste et libellé court.
const iso = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
const shifted = (date, days) => new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);
const parsed = (value) => new Date(`${value}T12:00:00`);
const monthShort = (date) => new Intl.DateTimeFormat("fr-CA", { month: "short" }).format(date);
const monthLong = (date) => new Intl.DateTimeFormat("fr-CA", { month: "long" }).format(date);

/** Semaine complète précédente, du dimanche au samedi. */
export function lastWeekPeriod(today = new Date()) {
  const sunday = shifted(today, -today.getDay() - 7);
  return { from: iso(sunday), to: iso(shifted(sunday, 6)) };
}

export function yesterdayPeriod(today = new Date()) {
  const day = iso(shifted(today, -1));
  return { from: day, to: day };
}

/** « AAAA-MM » → premier et dernier jour du mois. */
export function monthPeriod(month) {
  if (!/^\d{4}-\d{2}$/.test(month || "")) return { from: "", to: "" };
  const [year, index] = month.split("-").map(Number);
  return { from: `${month}-01`, to: iso(new Date(year, index, 0)) };
}

/** Mois que couvrent exactement ces deux dates, sinon "". */
export function periodMonth(from, to) {
  const month = String(from || "").slice(0, 7);
  const period = monthPeriod(month);
  return period.from && period.from === from && period.to === to ? month : "";
}

export function recentMonths(today = new Date(), count = 12) {
  return Array.from({ length: count }, (_, index) => {
    const first = new Date(today.getFullYear(), today.getMonth() - index, 1);
    const label = new Intl.DateTimeFormat("fr-CA", { month: "long", year: "numeric" }).format(first);
    return { value: iso(first).slice(0, 7), label: label.charAt(0).toUpperCase() + label.slice(1) };
  });
}

/** « 2 → 13 oct. », « 27 sept. → 3 oct. » ou « 9 oct. ». */
export function periodLabel(from, to) {
  if (!from || !to) return "";
  const start = parsed(from), end = parsed(to);
  if (from === to) return `${end.getDate()} ${monthShort(end)}`;
  const sameMonth = start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();
  return `${start.getDate()}${sameMonth ? "" : ` ${monthShort(start)}`} → ${end.getDate()} ${monthShort(end)}`;
}

/** « 1er septembre », « 19 octobre ». */
export function dayWords(value) {
  if (!value) return "";
  const date = parsed(value);
  return `${date.getDate() === 1 ? "1er" : date.getDate()} ${monthLong(date)}`;
}

/** « du 4 au 10 octobre 2026 » : même texte que le courriel d'annulation (transport_statement_online._period). */
export function periodWords(from, to) {
  if (!from || !to) return "";
  const start = parsed(from), end = parsed(to);
  const tail = `${end.getDate()} ${monthLong(end)} ${end.getFullYear()}`;
  if (from === to) return `du ${tail}`;
  const sameMonth = start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();
  const sameYear = start.getFullYear() === end.getFullYear();
  return `du ${start.getDate()}${sameMonth ? "" : ` ${monthLong(start)}${sameYear ? "" : ` ${start.getFullYear()}`}`} au ${tail}`;
}

/** Jours distincts d'un relevé : « du 6, 7 et 9 oct. », « du 7 oct. » ou, sur deux mois, « du 30 sept. au 2 oct. ». */
export function serviceDaysLabel(dates) {
  const days = [...new Set((dates || []).filter(Boolean))].sort();
  if (!days.length) return "";
  const first = days[0], last = days[days.length - 1];
  if (first.slice(0, 7) !== last.slice(0, 7)) return `du ${periodLabel(first, first)} au ${periodLabel(last, last)}`;
  const numbers = days.map((day) => String(Number(day.slice(8))));
  const list = numbers.length > 1 ? `${numbers.slice(0, -1).join(", ")} et ${numbers[numbers.length - 1]}` : numbers[0];
  return `du ${list} ${monthShort(parsed(first))}`;
}
